function SummaryCard({ icon, title, value, sub, color='#0E7C7B', onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: '#fff',
        borderRadius: 8,
        padding: '1.25rem',
        borderLeft: `4px solid ${color}`,
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        cursor: onClick ? 'pointer' : 'default',
        transition: onClick ? 'transform 0.1s, box-shadow 0.1s' : 'none',
        userSelect: 'none',
      }}
      onMouseEnter={e => { if(onClick){ e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 4px 8px rgba(0,0,0,0.12)'; }}}
      onMouseLeave={e => { if(onClick){ e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; }}}
    >
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'0.5rem' }}>
        <div style={{ fontSize:'0.8rem', color:'#64748B', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.04em' }}>
          {title}
        </div>
        <span style={{ fontSize:'1.25rem' }}>{icon}</span>
      </div>
      <div style={{ fontSize:'1.5rem', fontWeight:800, color:'#1B2A4A', marginBottom:'0.25rem', lineHeight:1.2 }}>
        {value}
      </div>
      {sub && (
        <div style={{ fontSize:'0.8rem', color, fontWeight:500 }}>
          {sub}
        </div>
      )}
    </div>
  );
}

export default SummaryCard;
